"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateExtendedData = void 0;
const lodash = __importStar(require("lodash"));
const date_1 = require("../date");
const error_1 = require("../error");
const commonTypeguard = __importStar(require("../typeguards"));
const { keyBy, chain, cloneDeep } = lodash;
const _cleanExtendedDataInput = (input) => {
    const { generatedDataKeyMap: _unused, ...remaining } = input;
    return remaining;
};
// TODO: update to utilize "recurringDateConfig" instead once there's "day" support
const _generateDateRangeArray = (dates) => {
    let { startDateStr } = dates;
    const dateOutput = [];
    // eslint-disable-next-line no-restricted-syntax
    while (dates.endDateStr.localeCompare(startDateStr) >= 0) {
        dateOutput.push(startDateStr);
        startDateStr = date_1.calc.addDays(startDateStr, 1);
    }
    return dateOutput;
};
const _addBaseDateToDataArray = (data, dateInput) => {
    const { baseDateStr, baseDateStrKey } = dateInput;
    return data.map((input) => {
        if (!(baseDateStrKey in input)) {
            return input;
        }
        return { ...input, [baseDateStrKey]: baseDateStr };
    });
};
// !TODO: @eldarshamukhamedov Move to dashboard
/**
 * Note: as we build upon our data spreading / extending / accumulating functionality,
 * we can look to reconstruct this accordingly with proper base and wrapper functions to
 * be more generic across multiple use cases.
 */
const generateExtendedData = (inputs, keyDrivers, methods, options = {}) => {
    if (inputs.length === 0 || methods.length === 0) {
        return [];
    }
    const clonedInput = cloneDeep(inputs);
    const useFillGroupDataMethod = methods.includes('fillGroupData');
    const useFillDateMethod = methods.includes('fillDate');
    const useExtendEndMethod = methods.includes('extendEnd');
    const { baseDateStrKey } = keyDrivers;
    const { dataGroupKey, identifierIdKey, extendEndDateStr } = options;
    const baseDates = [];
    const identifierIds = new Set();
    // "baseDate" should be unique at the input level, thus just using array.
    // Can readjust if the provided input structure changes to manage duplicates
    for (const input of clonedInput) {
        const dateValue = input[baseDateStrKey];
        (0, error_1.finleyAssert)(commonTypeguard.isFullDateStr(dateValue), `Expected FullDateStr type [key:${baseDateStrKey}] [value:${dateValue}]`);
        baseDates.push(dateValue);
        if (useFillGroupDataMethod) {
            (0, error_1.finleyAssert)(dataGroupKey && identifierIdKey, `Require [dataGroupKey, identifierIdKey] when filling group data`);
            for (const item of input[dataGroupKey]) {
                const identifierId = item[identifierIdKey];
                (0, error_1.finleyAssert)(identifierId && typeof identifierId === 'string', `Expected string value [key:${identifierIdKey}] [value:${identifierId}]`);
                identifierIds.add(identifierId);
            }
        }
    }
    const dataKeyByDateMap = chain(clonedInput)
        .keyBy(baseDateStrKey)
        .mapValues((input) => {
        if (useFillGroupDataMethod) {
            (0, error_1.finleyAssert)(dataGroupKey && identifierIdKey, `Require [dataGroupKey, identifierIdKey] when filling group data`);
            // Adding "generatedDataKeyMap" attribute to act as a map to facilitate simple lookup
            // using provided "identifierIdKey" to retrieve target data (i.e., avoid nested looping)
            // eslint-disable-next-line no-param-reassign
            input.generatedDataKeyMap = keyBy(input[dataGroupKey], identifierIdKey);
        }
        return input;
    })
        .value();
    let sortedDates = baseDates.sort((aDate, bDate) => aDate.localeCompare(bDate));
    if (useFillDateMethod) {
        sortedDates = _generateDateRangeArray({
            startDateStr: sortedDates[0],
            endDateStr: sortedDates[sortedDates.length - 1],
        });
    }
    const firstDataInstance = dataKeyByDateMap[sortedDates[0]];
    (0, error_1.finleyAssert)(firstDataInstance, `Failed to find first data instance [date:${sortedDates[0]}] [baseDateStrKey:${baseDateStrKey}]`);
    const adjustedDataFilledArray = [
        _cleanExtendedDataInput(firstDataInstance),
    ];
    // Starting at idx 1 since we're only filling data based on available prior data.
    // Thus, if data wasn't available previously, we will not backfill data at the moment
    // eslint-disable-next-line no-restricted-syntax, no-plusplus
    for (let idx = 1; idx < sortedDates.length; ++idx) {
        const baseDateStr = sortedDates[idx];
        const priorDataObject = dataKeyByDateMap[sortedDates[idx - 1]];
        let currentDataObject = dataKeyByDateMap[baseDateStr];
        if (useFillDateMethod) {
            // If the current date object is not present, then carry forward prior data object
            if (!currentDataObject && priorDataObject) {
                const baseObject = _addBaseDateToDataArray([priorDataObject], {
                    baseDateStrKey,
                    baseDateStr,
                })[0];
                if (dataGroupKey && dataGroupKey in baseObject) {
                    const baseObjectGroupData = _addBaseDateToDataArray(baseObject[dataGroupKey], { baseDateStrKey, baseDateStr });
                    baseObject[dataGroupKey] = baseObjectGroupData;
                }
                dataKeyByDateMap[baseDateStr] = baseObject;
                currentDataObject = dataKeyByDateMap[baseDateStr];
            }
        }
        if (useFillGroupDataMethod) {
            (0, error_1.finleyAssert)(dataGroupKey && identifierIdKey, `Require [dataGroupKey, identifierIdKey] when filling group data`);
            for (const identifierId of identifierIds) {
                // If data is already present, then no data updating is needed.
                // Otherwise, we will want to utilize the prior "date" (idx - 1)
                // version as data filler if it is available for use.
                if (currentDataObject.generatedDataKeyMap[identifierId]) {
                    continue;
                }
                const priorData = priorDataObject.generatedDataKeyMap?.[identifierId];
                if (!priorData) {
                    continue;
                }
                const adjustedPriorData = _addBaseDateToDataArray([priorData], {
                    baseDateStrKey,
                    baseDateStr,
                })[0];
                currentDataObject[dataGroupKey].push(adjustedPriorData);
                currentDataObject.generatedDataKeyMap[identifierId] = adjustedPriorData;
            }
        }
        adjustedDataFilledArray.push(_cleanExtendedDataInput(currentDataObject));
    }
    if (useExtendEndMethod) {
        (0, error_1.finleyAssert)(extendEndDateStr, `Require [endDate] when extending data`);
        const lastDataPoint = adjustedDataFilledArray[adjustedDataFilledArray.length - 1];
        let lastSeenDateStr = lastDataPoint[baseDateStrKey];
        (0, error_1.finleyAssert)(commonTypeguard.isFullDateStr(lastSeenDateStr), `Expected FullDateStr type [key:${baseDateStrKey}] [value:${lastSeenDateStr}]`);
        // Increment by 1 to skip existing end date for initial comparison against target end date
        lastSeenDateStr = date_1.calc.addDays(lastSeenDateStr, 1);
        // eslint-disable-next-line no-restricted-syntax
        while (extendEndDateStr.localeCompare(lastSeenDateStr) >= 0) {
            adjustedDataFilledArray.push({
                ...lastDataPoint,
                [baseDateStrKey]: lastSeenDateStr,
            });
            lastSeenDateStr = date_1.calc.addDays(lastSeenDateStr, 1);
        }
    }
    return adjustedDataFilledArray;
};
exports.generateExtendedData = generateExtendedData;
//# sourceMappingURL=dataExtension.js.map